import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { computed, watch } from 'vue';
import { useUiStore } from "@/stores/ui";
import { onKeyStroke } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'itemModal',
  props: {
  uiId: {
    type: String,
    default: "",
  },
  center: {
    type: Boolean,
    default: false,
  },
  top: {
    type: Number,
    default: 0,
  },
  left: {
    type: Number,
    default: 0,
  }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const uiStore = useUiStore();

const emits = __emit;
const props = __props;

onKeyStroke('Escape', () => {
  closeFCT();
});

const position = computed (() => {
  if (props.center === true) {
    return 'grid-column: middle / right; grid-row: top / end-row;'
  } else {
    return `position: absolute; top: ${props.top}px; left: ${props.left}px;`
  }
})

const showThisModal = computed(() => {
  const thisUiId = props.uiId
  const storeModalUiId = uiStore.modalUiId
  return (thisUiId === "") ? false : (thisUiId === storeModalUiId)
})


function triggerFCT() {
  uiStore.setModalUiId(props.uiId)
}

function closeFCT() {
  uiStore.setModalUiId("")
}

watch(showThisModal, (newVal, oldVal) => {
    if (oldVal && !newVal) {
      emits('close')
    }
  },
  { flush: 'sync' }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _withModifiers(triggerFCT, ["left"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (showThisModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-mask z-modal1",
            onClick: closeFCT
          }, [
            _createElementVNode("div", {
              style: {"position":"absolute","height":"100vh","width":"100vw"},
              class: "grid",
              onKeyup: _withKeys(closeFCT, ["esc"])
            }, [
              _createElementVNode("div", {
                style: _normalizeStyle(position.value)
              }, [
                _renderSlot(_ctx.$slots, "modal")
              ], 4)
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})